<template>
  <div class="order-submit">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack"><img src="@/assets/img/appointment/back.svg" /></div>
      <div class="nav-title d-allcenter overflow">退款详情</div>
      <div class="nav-right"></div>
    </div>
    <div style="margin-top: 44px; background: #f9f9f9; padding-top: 16px">
      <div class="order-info fs-sm">
        <div class="d-column d-aligncnter">
          <div class="fs-md">退款金额</div>
          <div class="weight"><span class="fs-lm">￥</span><span style="font-size: 36px">25</span></div>
        </div>

        <div class="d-aligncnter d-between mt-8">
          <div class="grey">账户</div>
          <div style="margin-left: 16px; color: #2f2f2f">￥25</div>
        </div>
        <div class="d-aligncnter d-between" style="margin-top: 4px">
          <div class="grey">支付渠道</div>
          <div style="margin-left: 16px; color: #2f2f2f">￥25</div>
        </div>
        <div class="d-aligncnter d-between" style="margin-top: 4px">
          <div class="grey">退款账户</div>
          <div style="margin-left: 16px; color: #2f2f2f">￥25</div>
        </div>
      </div>

      <div class="order-info fs-sm" style="margin-top: 8px">
        <div style="height: 160px">
          <el-steps direction="vertical" :active="stepActive">
            <el-step title="提交申请" description="2022-02-02 12:23:21"></el-step>
            <el-step :title="'退款受理' + (stepActive == 1 ? '中' : '')" description="2022-02-02 12:23:21"></el-step>
            <el-step title="到账成功" description="2022-02-02 12:23:21"></el-step>
          </el-steps>
        </div>
      </div>
      <!-- <div class="pt-16" style="font-size: 14px">预约详情</div> -->
      <!-- <div class="order-line">
        <div class="d-aligncnter">
          <div style="width: 80px; height: 80px; border-radius: 2px; overflow: hidden" class="d-allcenter">
            <el-image
              style="width: 80px; height: 80px"
              :src="require('@/assets/img/appointment/demo.png')"
              fit="cover"
            ></el-image>
          </div>
          <div style="margin-left: 16px">
            <div>北校区XX场馆网球场</div>
            <div>2024-01-22 8:00-9:00</div>
          </div>
        </div>
        <div class="d-end" style="margin-top: 8px; flex-direction: row-reverse">
          <button size="small" class="full-btn" @click.stop="pageToPay">去支付</button>
          <button size="small" class="plain-btn" @click.stop="cancelOrder">取消</button>
          <button size="small" class="plain-btn" @click.stop="drawback">申请退款</button>
        </div>
      </div>
      <div class="order-line mt-8 d-between">
        <div>订单编号</div>
        <div>2024010212121212349</div>
      </div>
      <div class="order-line mt-8 d-between">
        <div>下单时间</div>
        <div>2024-01-02 12:12:12</div>
      </div>
      <div class="order-line mt-8 d-between">
        <div>订单金额</div>
        <div>￥20</div>
      </div> -->
    </div>
    <!-- <div class="d-between bottom-sub">
      <div style="margin-left: 16px">金额：￥20</div>
      <div class="submit d-allcenter">提交订单</div>
    </div> -->
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      title: '订单确认',
      stepActive: 1,
    }
  },
  onLoad() {},

  computed: {},
  methods: {
    pageToBack() {
      this.$router.go(-1)
    },
    drawback() {},
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.order-submit {
  height: calc(100vh - 44px);
  background: #f9f9f9;
}
.mt-8 {
  margin-top: 8px;
}
.pt-16 {
  padding: 16px;
}
.submit {
  background: #007a4d;
  color: #fff;
  width: 100px;
  height: 44px;
  font-size: 14px;
}
.order-line {
  width: calc(100% - 32px);
  background: #fff;
  padding: 16px;
  font-size: 14px;
}
.bottom-sub {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 44px;
  background: #fff;
  line-height: 44px;
}
.plain-btn {
  border: 1px solid #339571;
  color: #339571;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background: #fff;
}
.full-btn {
  background-color: #339571;
  color: #fff;
  border: 1px solid #339571;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.order-info {
  border-radius: 8px;
  background: #fff;
  //   box-shadow: 0px 2px 4px 0px #e8e8e8;
  padding: 16px;
  margin: 0 16px;
  width: calc(100% - 64px);
}

.order-info ::v-deep .el-step__head.is-finish {
  color: #fff;
  border-color: #99cab8;
}
.order-info ::v-deep .is-finish .el-step__icon.is-text {
  background: #339571;
}
.order-info ::v-deep .el-step__title.is-finish {
  color: #339571;
}
.order-info ::v-deep .el-step__description.is-finish {
  color: #747474;
}
</style>
